import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navigation from "../../../common/components/Navigation/Navigation";
import StepperMUI from "../../../common/components/Stepper/Stepper";
import { CreateProjectGroupName, CreateProjectGroupThumbnail } from "src/pages/ProjectGroups";

export default function DuplicateProjectGroupWrapper() {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const incrementStep = () => setStep(step + 1);
  const decrementStep = () => setStep(step - 1);

  const renderStep = (step: number) => {
    switch (step) {
      case 0:
      default:
        return <CreateProjectGroupName incrementStep={incrementStep} mode="duplicate" />;
      case 1:
        return <CreateProjectGroupThumbnail decrementStep={decrementStep} mode="duplicate" />;
    }
  };

  return (
    <>
      <Navigation title={t("pages.duplicateProjectGroup.title")} />
      <StepperMUI step={step} mode="duplicateProjectGroup" />
      {renderStep(step)}
    </>
  );
}
